export default function (props: any) {
    return (
        <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="smart-home-pan" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="smart-home-panel" transform="translate(-1294.000000, -8766.000000)">
                    <g id="播放按钮-icon" transform="translate(1294.000000, 8766.000000)">
                        <circle id="椭圆形" fillOpacity="0.421403792" fill="#FFFFFF" cx="17" cy="17" r="17"></circle>
                        <path
                            d="M16.9144033,12.1711933 C13.6479686,12.1711933 11,14.8191619 11,18.0855967 C11,21.3520314 13.6479686,24 16.9144033,24 C20.1808381,24 22.8288067,21.3520314 22.8288067,18.0855967 C22.8288067,16.6797595 22.3383113,15.3884836 21.5191184,14.3735669"
                            id="路径"
                            stroke="#1A1A1A"
                            strokeWidth="2"
                            strokeLinecap="round"
                        ></path>
                        <polyline
                            id="路径"
                            stroke="#1A1A1A"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(15.383542, 12.386505) rotate(-48.000000) translate(-15.383542, -12.386505) "
                            points="17.0733717 10.6966752 17.0733717 14.0763342 13.6937126 14.0763342"
                        ></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}
